import { helpGetOrganizationWithID } from "../../app/services/Organization/helpGetOrganizationWithID"
import { userActionTypes } from "../constants/action-types"
// decode token
// eslint-disable-next-line
import jwt_decode from "jwt-decode"
import { getTypesOrganizations } from "./Organizations"
import { setErrorTextSnackBar, setRequestTextSnackBar } from "./app"
import { helpGetTypesUser } from "../../app/services/user/helpgetTypeUser"
import library from "../../utils/Library"
import { helpUpdateUserofOrganizationLoginAccount } from "../../app/services/LoginAccount/UpdateUserInfo"
import { helpUpdateTypeUserofOrganization } from "../../app/services/Organization/helpUpdateTypeUserOrganization"
import { deleteCustomerUserCorp } from "../../app/services/CorporateCustomers/deleteCustomerUserCorpCustomer"
// ----------------------------
// LOGIN
// ----------------------------
export const loginRequest = () => {
  return {
    type: userActionTypes.LOGIN_REQUEST,
  }
}

export const loginSuccess = (accessToken) => {
  return {
    type: userActionTypes.LOGIN_SUCCESS,
    payload: accessToken,
  }
}
export const loginFailure = (error) => {
  return {
    type: userActionTypes.LOGIN_FAILURE,
    payload: error,
  }
}

export const LogOutUser = () => {
  return async (dispatch) => {
    dispatch(logout())
    const accountsRedirect = library.getBaseAPIUrl("logout")
    document.cookie =
      "syserrepar_JWT2=; path=/; max-age=0; SameSite=Strict; Secure"
    document.cookie = "webcgi_JWT2=; path=/; max-age=0; SameSite=Strict; Secure"
    window.location.href = accountsRedirect
  }
}

const logout = () => {
  return {
    type: userActionTypes.LOGOUT_USER,
  }
}

// ----------------------------
// VALIDATIONS USER
// ----------------------------

// if user logged of organization MAIN
export const authenticateUser = (token = null) => {
  return async (dispatch) => {
    const decoded = jwt_decode(token)

    try {
      // CHANGE WHEN THERE IS A STABLE ENVIRONMENT **
      // PROD
      // const orgData = await helpGetOrganizationWithID(
      //   decoded.loginAccountData.organizationId,
      //   token
      // )
      // // DEV
      const orgData = await helpGetOrganizationWithID(
        decoded.applicationData?.entityData?.organizationId,
        token,
      )
      const types = await dispatch(getTypesOrganizations(token))
      const typeMain = types.findIndex(
        (type) => type.organizationTypeCode === "MAIN-ORG",
      )
      if (typeMain === -1) {
        return new Error().name
      }
      return (
        types[typeMain].organizationTypeId ===
        orgData.data?.data?.organizationTypeId
      )
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar(
          "Ocurrió un error en el servicio" +
            error.response?.data?.codeMessageLanguage
            ? ": " + error.response?.data?.codeMessageLanguage
            : "",
        ),
      )
      return error.name
    }
  }
}

// -----------------
// USER INFORMATION
// -----------------

export const getAllTypesUser = () => {
  return async (dispatch) => {
    try {
      const response = await helpGetTypesUser()
      return response.data.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: OrganizationAPI",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
      // dispatch(setRequestTextSnackBar())
      // dispatch(
      //   setErrorTextSnackBar(
      //     'Ocurrió un error en el servicio',
      //     error.response?.data?.codeMessageLanguage
      //       ? ': ' + error.response?.data?.codeMessageLanguage
      //       : ''
      //   )
      // )
      return []
    }
  }
}

export const updateUserStatusLoginAccount = (user) => {
  return async (dispatch) => {
    try {
      const response = await helpUpdateUserofOrganizationLoginAccount(user)
      return response?.data?.save
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      if (error.response?.status === 404) {
        dispatch(setErrorTextSnackBar("Ocurrió un error. Intente más tarde"))
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error:" + error.response?.data?.codeMessageLanguage,
          ),
        )
      }
      return { error: true }
    }
  }
}

export const updateUserOrganization = (user) => {
  return async (dispatch) => {
    try {
      const response = await helpUpdateTypeUserofOrganization(user)
      return response?.data?.data
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      if (error.response?.status === 404) {
        dispatch(setErrorTextSnackBar("Ocurrió un error. Intente más tarde"))
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error:" + error.response?.data?.codeMessageLanguage,
          ),
        )
      }
      return { error: true }
    }
  }
}

export const deleteCustomerUser = (params) => {
  return async (dispatch) => {
    try {
      const response = await deleteCustomerUserCorp(params)
      return response.data
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      if (error.response?.status === 404) {
        dispatch(setErrorTextSnackBar("Ocurrió un error. Intente más tarde"))
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error:" + error.response?.data?.codeMessageLanguage,
          ),
        )
      }
      return { error: true }
    }
  }
}

export const updateUserStatusLoginAccot = (user) => {
  return async (dispatch) => {
    try {
      const response = await helpUpdateUserofOrganizationLoginAccount(user)
      return response?.data?.save
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      if (error.response?.status === 404) {
        dispatch(setErrorTextSnackBar("Ocurrió un error. Intente más tarde"))
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error:" + error.response?.data?.codeMessageLanguage,
          ),
        )
      }
      return { error: true }
    }
  }
}
